import { MassActionCombinationItem } from '../../../../stores/ProductDetails/productDetails.types';
import { AvailabilityEnum } from '../../ProductTypes';

export interface MountProductDetailsCombinationItemParams {
  productColorId: string;
  availability: AvailabilityEnum;
  orderId?: string;
  deliveryWindowId?: string | null;
}

export interface VerifyIfCombinationItemsAreEqualParams {
  item1: MassActionCombinationItem;
  item2: MassActionCombinationItem;
}

export const mountProductDetailsCombinationItem = ({
  productColorId,
  deliveryWindowId,
  orderId,
  availability,
}: MountProductDetailsCombinationItemParams): MassActionCombinationItem => {
  return {
    productColorId,
    availability: availability,
    deliveryWindowId: deliveryWindowId ?? undefined,
    orderId: orderId ?? '',
  };
};

export const verifyIfCombinationItemsAreEqual = ({
  item1,
  item2,
}: VerifyIfCombinationItemsAreEqualParams): boolean => {
  return (
    item1.productColorId === item2.productColorId &&
    item1.availability === item2.availability &&
    item1.deliveryWindowId === item2.deliveryWindowId &&
    item1.orderId === item2.orderId
  );
};
